import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMG } from "@/lib/content";
import { Reveal } from "@/components/motion/Reveal";

const WORLDS = [
  {
    id: "privat",
    label: "Privat",
    title: ["Zuhause soll sich", "sauber anfühlen."],
    items: ["Wohnungen", "Einfamilienhäuser", "Umzug", "Fenster", "Garten"],
    to: "/privatreinigung",
    img: IMG.privat,
    dark: false,
  },
  {
    id: "business",
    label: "Business",
    title: ["Professionelle Räume", "brauchen professionelle Pflege."],
    items: ["Büros", "Praxen", "Gewerbe", "Liegenschaften", "Verwaltungen"],
    to: "/geschaeftskunden",
    img: IMG.business,
    dark: true,
  },
];

export function DualWorlds() {
  const [hover, setHover] = useState(null);
  return (
    <section className="bg-ink" aria-label="Privat und Business">
      <div className="flex flex-col lg:flex-row lg:h-[92vh] lg:min-h-[680px]">
        {WORLDS.map((w) => {
          const expanded = hover === w.id;
          const shrunk = hover && hover !== w.id;
          return (
            <Link
              key={w.id}
              to={w.to}
              data-testid={`dual-world-tab-${w.id}`}
              onMouseEnter={() => setHover(w.id)}
              onMouseLeave={() => setHover(null)}
              className={`group relative overflow-hidden flex flex-col justify-between min-h-[80svh] lg:min-h-0 transition-[flex] duration-[1100ms] ease-out ${
                expanded ? "lg:flex-[1.35]" : shrunk ? "lg:flex-[0.65]" : "lg:flex-1"
              } ${w.dark ? "text-paper" : "text-ink"}`}
            >
              <img
                src={w.img}
                alt=""
                loading="lazy"
                decoding="async"
                sizes="(min-width: 1024px) 50vw, 100vw"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105"
              />
              <div className={`absolute inset-0 ${w.dark ? "bg-gradient-to-t from-ink/90 via-ink/40 to-ink/30" : "bg-gradient-to-t from-paper/95 via-paper/50 to-paper/10"}`} />
              <div className="relative z-10 p-8 md:p-12 flex justify-between label opacity-80">
                <span>{w.label}</span>
                <span>{w.id === "privat" ? "04.1" : "04.2"}</span>
              </div>
              <div className="relative z-10 p-8 md:p-12">
                <Reveal>
                  <h2 className="display text-4xl sm:text-5xl lg:text-[3.6vw] leading-[0.98] max-w-[14ch]">
                    {w.title[0]}<br />{w.title[1]}
                  </h2>
                </Reveal>
                <Reveal delay={0.1} className="mt-8 flex flex-wrap gap-x-6 gap-y-2 label opacity-70">
                  {w.items.map((it) => <span key={it}>{it}</span>)}
                </Reveal>
                <div className="mt-10 label inline-flex items-center gap-2 link-line">
                  Mehr erfahren <ArrowUpRight size={12} strokeWidth={1.5} />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
